/** eslint-disable react/react-in-jsx-scope -- Unaware of jsxImportSource */
/** @jsxImportSource @emotion/react */

import "../assets/scss/public-main.scss";

import React from 'react';
import {CssBaseline} from "@mui/material";
import ListingMainAttributes from "../components/views-public/Listing.MainAttributes.tsx";
import ListingPhotos from "../components/views-public/Listing.Photos.tsx";
import ListingDetailTabs from "../components/views-public/Listing.DetailTabs.tsx";
import SingleListingProvider from "../components/context/SingleListingProvider.tsx";
import ListingHeader from "../components/views-public/Listing.Header.tsx";
import ListingDetailAccordions from "../components/views-public/Listing.DetailAccordions.tsx";
import ListingBrokers from "../components/views-public/Listing.Brokers.tsx";
import usePrerenderIo from "../hooks/usePrerenderIo.ts";

type Props = {}
const PublicListingSingle = (props: Props) => {

    // explicitly tell Prerender.io when to start caching HTML after it's mostly rendered (helps to speed it up)
    usePrerenderIo();

    return <React.Fragment>
        <CssBaseline/>

        <SingleListingProvider>
            {/* main header w/ property type, address, price, etc. */}
            <ListingHeader/>
            {/* photos carousel */}
            <ListingPhotos/>
            {/* main highlights of the property */}
            <ListingMainAttributes/>
            {/* tabs showing further details grouped by type */}
            <ListingDetailTabs/>
            {/* accordions for addenda & renovations */}
            <ListingDetailAccordions/>
            {/* cards for brokers involved in this listing */}
            <ListingBrokers/>
        </SingleListingProvider>
    </React.Fragment>
}
export default PublicListingSingle;
